import React from 'react';
import axios from 'axios';
import { useAlerts } from 'components/Alerts';

const ResubscribeButton = ({
  resubscribePath,
  label,
}) => {
  const alerts = useAlerts();
  const [loading, setLoading] = React.useState(false);

  const resubscribe = () => {
    setLoading(true);

    axios.post(resubscribePath)
      .then(() => {
        window.location.href = `${window.location.protocol}//${window.location.host}${location.pathname}?resubscribed`
      })
      .catch(() => {
        alerts.error('Could not subscribe to this project');
      })
      .finally(() => setLoading(false));
  }

  return (
    <button
      id="subscribe-button"
      className="btn btn-primary"
      disabled={loading}
      onClick={() => {resubscribe()}}
    >
      {label}
    </button>
  );
};

export default ResubscribeButton;
